<script setup lang="ts">
import type { BreadcrumbProps } from '#seo-utils/app/composables/useBreadcrumbItems'

interface Props extends Pick<BreadcrumbProps, 'overrides'> {
  showBreadcrumbs?: boolean
}

const { overrides, showBreadcrumbs = true } = defineProps<Props>()

setNavigationContext('marketing')

useHead({
  htmlAttrs: {
    class: 'bg-blurple-500',
  },
})
</script>

<template>
  <LayoutContainer>
    <Header class="dark-mode !bg-primary [&_svg]:fill-blurple-200 text-blurple-100 [&_li>a:hover]:bg-blurple-400 [&_a.active:not(:hover)]:text-primary [&_[data-dropdown-trigger='closed']]:text-primary-on_dark [&_[data-dropdown-trigger='closed']:hover]:bg-blurple-400" />
    <ContentGrid v-if="showBreadcrumbs" class="w-full dark-mode">
      <Breadcrumbs :overrides="overrides" class="full-width" />
    </ContentGrid>
    <main class="flex-1">
      <slot />
    </main>
    <NettbutikkFooterCta />
    <Footer class="dark-mode" wide />
  </LayoutContainer>
</template>
